export const MuiButton = {
  styleOverrides: {
    text: {
      fontSize: '12px',
      color: '#a8aeb8',
    },
  },
};
